module.exports = __webpack_public_path__ + "img/zhengchang.54c51474.png";